__turbopack_context__.v({
  "arrow": "collapsibleSectionList-module-scss-module__N38FQa__arrow",
  "panel": "collapsibleSectionList-module-scss-module__N38FQa__panel",
  "panelContent": "collapsibleSectionList-module-scss-module__N38FQa__panelContent",
  "panelHeader": "collapsibleSectionList-module-scss-module__N38FQa__panelHeader",
});
